:host {
  /**
  These custom properties can be set by merchants to customize the banner display,
  so they should be considered public API -- preserve backwards compatibility.
  To avoid clashing with existing custom properties, all properties should be prefixed by `--og-banner-`
  */

  /* Banner properties */
  --og-banner-bg: linear-gradient(90deg, #c44545 0%, #a33030 100%);
  --og-banner-success-bg: linear-gradient(90deg, rgb(37, 99, 235) 0%, rgb(30, 64, 175) 100%);
  --og-banner-animation-duration: 1.7s;
  --og-banner-animation-easing: ease-in-out;
  /* NOTE: keyframe names do not pierce the shadow DOM. The only valid override for this property (from outside the component) is `none` to disable the animation. */
  --og-banner-animation: banner-bounce var(--og-banner-animation-duration) var(--og-banner-animation-easing) infinite;

  /* Banner fonts */
  --og-banner-font: system-ui, sans-serif;
  --og-banner-font-size: 14px;
  --og-banner-font-color: #fff;

  /* CTA button properties */
  --og-banner-cta-font: var(--og-banner-font, inherit);
  --og-banner-cta-font-color: var(--og-banner-font-color, inherit);

  /* Dismiss button properties */
  --og-banner-dismiss-bg: #fff;
  --og-banner-dismiss-color: #17132f;

  font-family: var(--og-banner-font);
}

.payment-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2147483647;
  display: flex;
  justify-content: center;
  margin: 32px 16px 0 16px;
  /* allow elements underneath the wrapper to be clicked */
  pointer-events: none;
}

.payment-alert {
  position: relative;
  background: var(--og-banner-bg);
  color: var(--og-banner-font-color);
  border-radius: 24px;
  padding: 10px 28px;
  font-size: var(--og-banner-font-size);
  line-height: 1.4;
  text-align: center;
  animation: var(--og-banner-animation);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px 8px;
  align-items: center;
  /* override pointer-events: none from the parent so the alert itself can be clicked */
  pointer-events: auto;

  &:hover {
    animation-play-state: paused;
  }

  /* focus styles for when the banner is programmatically focused */
  &:focus-visible {
    outline: 2px solid;
    outline-offset: -5px; /* inset to make sure it isn't lost on a white background */
  }
}

.payment-alert--success {
  background: var(--og-banner-success-bg);
  animation: none;
}

@keyframes banner-bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
}

.message {
  font-weight: 500;
  display: flex;
  gap: 8px;
  align-items: center;
}

.payment-update-button {
  all: unset; /* remove default button styles */
  color: var(--og-banner-cta-font-color);
  font-family: var(--og-banner-cta-font);
  text-decoration: underline;
  cursor: pointer;
  font-weight: 700;
  transition: opacity 100ms ease;

  &:focus-visible {
    outline: 1px solid;
    outline-offset: 2px;
  }
}

.payment-update-button--loading {
  opacity: 0.5;
}

.checkmark-icon {
  width: 16px;
  height: 16px;
  display: block;
  flex-shrink: 0;
}

.payment-alert-dismiss {
  all: unset;
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--og-banner-dismiss-bg);
  color: var(--og-banner-dismiss-color);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  transition: opacity 150ms ease;

  &:focus-visible {
    outline: 2px solid var(--og-banner-dismiss-color);
    outline-offset: 2px;
  }
}

@media (hover: hover) {
  .payment-alert-dismiss {
    opacity: 0;
  }

  .payment-alert:hover .payment-alert-dismiss,
  .payment-alert:focus-within .payment-alert-dismiss {
    opacity: 1;
  }
}
